var version = {
    "name":      "dativery",
    "buildDateCode": "20260615-151354",
    "buildDate": "Mon Jun 15 2026 15:13:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260615-151354",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;